import React, { useState } from "react";

export const IconCloudSQL: React.FC<React.HTMLAttributes<SVGElement>> = (
  props
) => {
  const [id] = useState(() => "_" + Math.random().toString(36).slice(2));
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      height="20px"
      viewBox="0 0 20 20"
      {...props}
    >
      <defs>
        <style>{`
        .${id}-1,
        .${id}-2,
        .${id}-3 {
          fill: currentColor;
          fill-rule: evenodd;
        }
        .${id}-2 {
          filter: brightness(0.79654747225);
        }
        .${id}-3 {
          fill: currentColor;
          filter: brightness(0.69667077681);
        }
      `}</style>
      </defs>
      <g>
        <polygon
          className={`${id}-1`}
          points="2.67 8.44 2.67 11.45 10 15.35 10 12.34 2.67 8.44"
        />
        <polygon
          className={`${id}-1`}
          points="2.67 13.09 2.67 16.1 10 20 10 16.99 2.67 13.09"
        />
        <polygon
          className={`${id}-2`}
          points="10 15.35 17.33 11.45 17.33 8.44 10 12.34 10 15.35"
        />
        <polygon
          className={`${id}-2`}
          points="10 20 17.33 16.1 17.33 13.09 10 16.99 10 20"
        />
        <polygon
          className={`${id}-3`}
          points="17.33 6.91 17.33 3.9 10 0 10 3.01 17.33 6.91"
        />
        <polygon
          className={`${id}-2`}
          points="10 0 2.67 3.9 2.67 6.91 10 3.01 10 0"
        />
        <polygon
          className={`${id}-1`}
          points="2.67 3.87 2.67 6.89 10 10.79 10 7.77 2.67 3.87"
        />
        <polygon
          className={`${id}-2`}
          points="10 10.79 17.33 6.89 17.33 3.87 10 7.77 10 10.79"
        />
      </g>
    </svg>
  );
};
